import 'es6-object-assign/auto';

import './c-tabs.scss';
import template from './tabs.vhtml';
import { historyComponentMixin } from '../../plugins/history';
import { trackPageview } from '../../scripts/tag-manager';

export default {
	template,
	mixins: [ historyComponentMixin ],
	props: {
		tabs: {
			type: Array,
			required: true,
		},
		selected: {
			type: Number,
			required: true,
		},
		capitalize: {
			type: Boolean,
			default: false,
		},
		trackPageviews: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({}),
	computed: {
		urlParam() {
			return this.history.queryParams.tab;
		},
	},
	watch: {
		selected() {
			this.history.setQueryParam( 'tab', this.tabs[ this.selected ].name );
		},
	},
	methods: {
		selectTab( index, preventVirtualPageview = false ) {
			this.$emit( 'select-tab', index );

			if ( !preventVirtualPageview && this.trackPageviews ) {
				// Wait for nextTick so we have the final history url available
				this.$nextTick()
					.then( () => trackPageview( document.location.href.replace( document.location.origin, '' ) ) );
			}
		},
		selectTabByName( tabName ) {
			if ( tabName !== undefined ) {
				const selectedTab = findWithAttr( this.tabs, 'name', tabName );
	
				if ( selectedTab !== -1 ) {
					this.selectTab( selectedTab, true );
				}
			}
		},
	},
	created() {
		this.selectTabByName( this.urlParam );
	},
};

function findWithAttr( array, attr, value ) {
	for ( let i = 0; i < array.length; i += 1 ) {
		if ( array[i][attr] && array[i][attr].toLowerCase() === value.toLowerCase() ) {
			return i;
		}
	}
	return -1;
}



// WEBPACK FOOTER //
// ./assets/_js/components/tabs/tabs.js